import { createSlice } from '@reduxjs/toolkit';

const initialAlertState = {
  open: false,
  title: '',
  message: '',
  isLoading: false,
};

const alertSlice = createSlice({
  name: 'alert',
  initialState: initialAlertState,
  reducers: {
    showAlert(state, action) {
      const { title, message, isLoading = false } = action.payload;

      return {
        open: true,
        title: title,
        message: message,
        isLoading: isLoading,
      };
    },
    closeAlert(state) {
      return {
        open: false,
        title: '',
        message: '',
        isLoading: false,
      };
    },
  },
});

export const alertActions = alertSlice.actions;

export default alertSlice.reducer;
